// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"c4fa8492","168":"d92323b7","216":"8211e580","224":"7d877c65","270":"059f116e","382":"55127585","397":"b19d8693","413":"21f51b58","484":"984c5db4","612":"583a5648","730":"963878b5","989":"840cb3d8"}[chunkId] + ".chunk.js";
};